// extracted by mini-css-extract-plugin
export default {"FloatingFeedbackItem":"FloatingFeedbackItem_FloatingFeedbackItem__AiOLc","icon":"FloatingFeedbackItem_icon__wrCgl","isError":"FloatingFeedbackItem_isError__ddoY4"};